"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNewsletterStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useNewsletterStore = (0, pinia_1.defineStore)('newsletterStore', {
    state: () => ({
        loading: false,
        newsletters: [],
        totalNewsletters: 0,
        highlightedNewsletters: []
    }),
    actions: {
        setLoading(loading) {
            this.loading = loading;
        },
        reset() {
            this.loading = false;
            this.newsletters = [];
            this.totalNewsletters = 0;
            this.highlightedNewsletters = [];
        },
        setNewsletters(newsletters, totalNewsletters) {
            this.newsletters = newsletters;
            this.totalNewsletters = totalNewsletters;
        },
        setHighlightedNewsletters(highlightedNewsletters) {
            this.highlightedNewsletters = highlightedNewsletters;
        },
        async getNewsletters(router, params = {}) {
            var _a;
            this.setLoading(true);
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_newsletters_api', query: params }).href);
                const newsletters = [];
                if (Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] !== 'Newsletter') {
                            return;
                        }
                        newsletters.push(element);
                    });
                }
                this.setNewsletters(newsletters, (_a = response['hydra:totalItems']) !== null && _a !== void 0 ? _a : 0);
                this.setLoading(false);
                return response;
            }
            catch (error) {
                console.error('Error fetching newsletters:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async getHighlightedNewsletters(router, params = {}) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_newsletters_api', query: params }).href);
                const highlightedNewsletters = [];
                if (Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] !== 'Newsletter') {
                            return;
                        }
                        highlightedNewsletters.push(element);
                    });
                }
                this.setHighlightedNewsletters(highlightedNewsletters);
                return response;
            }
            catch (error) {
                console.error('Error fetching highlighted newsletters:', error);
                throw error;
            }
        },
        async createNewsletter(router, newsletterRequest) {
            this.setLoading(true);
            const options = { body: JSON.stringify(newsletterRequest), method: 'POST' };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_newsletters_api' }).href, options);
                this.setLoading(false);
                return response;
            }
            catch (error) {
                console.error('Error creating newsletter:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async updateNewsletter(router, params) {
            this.setLoading(true);
            const options = { body: JSON.stringify(params.newsletterRequest), method: 'PUT' };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_newsletters_api', params: { id: params.id } }).href, options);
                this.setLoading(false);
                return response;
            }
            catch (error) {
                console.error('Error updating newsletter:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async deleteNewsletter(router, newsletter) {
            this.setLoading(true);
            try {
                await (0, fetch_1.default)(router.resolve({ name: 'admin_newsletters_api', params: { id: (Number(newsletter.id)).valueOf() } }).href, { method: 'DELETE' });
                this.setLoading(false);
            }
            catch (error) {
                console.error('Error deleting newsletter:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async newsletterBulkDelete(router, ids) {
            this.setLoading(true);
            const options = { method: 'DELETE', body: JSON.stringify({ selectedNewsletterIds: ids }) };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_newsletter_bulk_delete_api' }).href, options);
                this.setLoading(false);
                return response;
            }
            catch (error) {
                console.error('Error bulk deleting newsletters:', error);
                this.setLoading(false);
                throw error;
            }
        }
    }
});
